import {
  OptionWithDataTestid,
  OptionWithDataTestidAndTwoValue,
  TranslationFunction
} from '@/types';

export const infoPickupBox = (
  $t: TranslationFunction
): OptionWithDataTestidAndTwoValue[] => [
  {
    label: $t('address'),
    value: 'street',
    value2: 'city',
    dataTestid: 'infoAddress'
  },
  {
    label: $t('languages'),
    value: 'uiLanguages',
    dataTestid: 'infoLanguages'
  },
  {
    label: $t('versionSW'),
    value: 'currentSWVersion',
    dataTestid: 'infoVersionSW'
  }
];

export const infoIntervalTime = (
  $t: TranslationFunction
): OptionWithDataTestid[] => [
  {
    label: $t('temperatureInterval'),
    value: 'temperatureSendDataFromPickupboxIntervalTime',
    dataTestid: 'infoTemperatureInterval'
  },
  {
    label: $t('temperatureAlarmInterval'),
    value: 'temperatureSendAlarmNotificationAfterIntervalTime',
    dataTestid: 'infoTemperatureAlarmInterval'
  }
];

export const infoDeliveryRulesBasicLocker = (
  $t: TranslationFunction
): OptionWithDataTestid[] => [
  {
    label: $t('deliveryExpirationTime'),
    value: 'deliveryKeepTime',
    dataTestid: 'infoDeliveryRulesBasicLockerKeepTime'
  },
  {
    label: $t('reminderMessageTime'),
    value: 'deliveryReminderMessagePeriod',
    dataTestid: 'infoDeliveryRulesBasicLockerKeepTime'
  },
  {
    label: $t('reservationExpirationTime'),
    value: 'reservationKeepTime',
    dataTestid: 'infoDeliveryRulesBasicLockerKeepTime'
  }
];

export const infoDeliveryRulesFridgeLocker = (
  $t: TranslationFunction
): OptionWithDataTestid[] => [
  {
    label: $t('deliveryExpirationTime'),
    value: 'deliveryKeepTime',
    dataTestid: 'infoDeliveryRulesBasicLockerKeepTime'
  },
  {
    label: $t('reminderMessageTime'),
    value: 'deliveryReminderMessagePeriod',
    dataTestid: 'infoDeliveryRulesBasicLockerKeepTime'
  },
  {
    label: $t('reservationExpirationTime'),
    value: 'reservationKeepTime',
    dataTestid: 'infoDeliveryRulesBasicLockerKeepTime'
  }
];
